<template>
  <v-card
    class="article-card card-wrapper d-flex"
    tile
    elevation="6"
    flat
    :to="'/news/' + article.slug"
    @click.native="scrollToTop"
  >
    <v-img
      :src="
        article.image
          ? article.image.fields.file.url
          : '@/assets/images/photo-1567427018141-0584cfcbf1b8.jpeg'
      "
    >
      <div class="article-card  d-flex flex-column justify-end">
        <div
          class="card-caption lightgray d-flex flex-column justify-space-between"
        >
          <v-card-title v-if="$i18n.locale === 'en'" class="card-title pa-0">
            {{ article.titleEn | truncate }}
          </v-card-title>
          <v-card-title v-if="$i18n.locale === 'pt'" class="card-title pa-0">
            {{ article.titlePt | truncate }}
          </v-card-title>
          <v-card-text class="card-date pa-0">
            {{ moment(article.data).format('DD MMMM YYYY') }}
          </v-card-text>
        </div>
      </div>
    </v-img>
  </v-card>
</template>

<script>
export default {
  name: 'ArticleCard',
  props: {
    article: {
      type: Object,
    },
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0)
    },
  },
}
</script>

<style lang="scss" scoped>
.card-wrapper {
  // border: 4px solid rgba(#f2f2f2, 0);
  // &:hover {
  //   border: 4px solid #268c79;
  // }
}

.article-card {
  height: 240px;
}

.card-caption {
  width: 100%;
  min-height: 80px;
  padding: 8px;
  position: absolute;
  opacity: 0.9;
}

.card-title {
  font-family: $heading-font-family;
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  text-transform: uppercase;
  overflow-wrap: normal;
  word-break: normal;
}

.card-date {
  font-family: $body-font-family;
  font-weight: lighter;
  font-size: 14px;
  text-align: right;
}
</style>
